import { DEFAULT_SELECTION_ALL } from '@utilities/constants';
import { CaseCommentDetails } from '@data/caseComments/types/CaseComments.types';

export const filterCommentsByType = (comments: CaseCommentDetails[], typeFilter: string) => {
	return comments?.length && typeFilter !== DEFAULT_SELECTION_ALL
		? comments.filter(comment => comment.types.toString().includes(typeFilter))
		: comments;
};
